import { Loading } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { companyService } from "../../shared/api/companyService";
import { useDetailsPageEntityLoader } from "../../shared/hooks";
import { StyledSection } from "../../shared/view";
import { ArchivedCompanyBanner } from "./ArchivedCompanyBanner";
import { ArchivedCompanyOverview } from "./ArchivedCompanyOverview";
import { CompanyViewAddressSection } from "./CompanyViewAddressSection";
import { CompanyViewGeneralSection } from "./CompanyViewGeneralSection";
import { CompanyViewTagsSection } from "./CompanyViewTagsSection";

const CompanySection = styled(StyledSection)`
	margin-top: 0;
`;

export const CompanyViewPage: FC = () => {
	const { data, isLoading } = useDetailsPageEntityLoader(companyService);

	if (!data || isLoading) {
		return <Loading />;
	}

	return (
		<>
			{data.isArchived && <ArchivedCompanyBanner id={data.id} />}
			<CompanySection color="content">
				{data.isArchived ? (
					<ArchivedCompanyOverview company={data} />
				) : (
					<>
						<CompanyViewGeneralSection company={data} />
						<CompanyViewAddressSection company={data} />
						<CompanyViewTagsSection company={data} />
					</>
				)}
			</CompanySection>
		</>
	);
};
